import { EnergyToggle } from './EnergyToggle';
import { IEnergy } from '../model/ICheckin';

export const EnergySelector: React.FC<{ value?: IEnergy, onChange: (value?: IEnergy) => Promise<void> }> = ({ value, onChange }) => {

    const onClick = async (energy: IEnergy) => {
        await onChange(energy === value ? undefined : energy);
    };

    return (
        <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'flex-start', gap: 20, maxWidth: 400, margin: '30px auto 10px'}}>
            <EnergyToggle
                energy={IEnergy.Low}
                selected={value === IEnergy.Low}
                disabled={value !== IEnergy.Low && value !== undefined}
                onClick={() => onClick(IEnergy.Low)}
            />
            <EnergyToggle
                energy={IEnergy.Medium}
                selected={value === IEnergy.Medium}
                disabled={value !== IEnergy.Medium && value !== undefined}
                onClick={() => onClick(IEnergy.Medium)}
            />
            <EnergyToggle
                energy={IEnergy.High}
                selected={value === IEnergy.High}
                disabled={value !== IEnergy.High && value !== undefined}
                onClick={() => onClick(IEnergy.High)}
            />
            <EnergyToggle
                energy={IEnergy.VeryHigh}
                selected={value === IEnergy.VeryHigh}
                disabled={value !== IEnergy.VeryHigh && value !== undefined}
                onClick={() => onClick(IEnergy.VeryHigh)}
            />
        </div>
    );
};
